import clsx from 'clsx'
import { useState } from 'react'

import { anim, prog } from '../../../motion'
import { Avatar } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { readParam, useCopy, writeParam } from '../../i18n'
import { DEMO_CASES } from '../copy'

// Branchen in Reihenfolge des ersten Auftretens, Schlüssel wie in ?branche=
const BRANCHES = [...new Set(DEMO_CASES.map((c) => c.branch))]

const readBranch = () => {
  const b = readParam('branche')
  return BRANCHES.includes(b) ? b : null
}

// Branchen-Filter und ein Kartenstreifen, der mit dem Scroll vorbeizieht
export default function DemoCases() {
  const c = useCopy('faelle')
  const [branch, setBranch] = useState(readBranch)
  const visible = DEMO_CASES.filter((k) => !branch || k.branch === branch)

  const choose = (next) => {
    writeParam('branche', next)
    setBranch(next)
  }

  const labelOf = (key) =>
    c.cases[DEMO_CASES.find((k) => k.branch === key).id].branch

  return (
    <div className='cin-full'>
      <div className='cin-pad cin-pad--top dm-cases-head'>
        <div className='cin-row-between'>
          <div>
            <Line at={[0, 0.06]} className='cin-eyebrow'>
              {c.eyebrow}
            </Line>
            <h2 className='cin-title'>
              <Words text={c.title} at={[0.02, 0.12]} />
            </h2>
          </div>
        </div>
        <div
          className='dm-filter'
          role='group'
          aria-label={c.filter}
          style={anim({ at: [0.06, 0.12], y: 20 })}
        >
          <span className='dm-filter__label'>{c.filter}</span>
          {[null, ...BRANCHES].map((key) => (
            <button
              key={key || 'all'}
              type='button'
              aria-pressed={branch === key}
              className={clsx('dm-filter__chip', branch === key && 'is-active')}
              onClick={() => choose(key)}
            >
              {key ? labelOf(key) : c.all}
            </button>
          ))}
        </div>
      </div>

      <div
        className='cin-strip dm-cases'
        style={{
          '--count': visible.length,
          ...prog([0.14, 0.94]),
          transform:
            'translateX(calc(var(--strip-start) - var(--p) * max(0px, var(--count) * var(--card) + (var(--count) - 1) * var(--gap) - 100cqw + 2 * var(--strip-start))))'
        }}
      >
        {visible.map((k, i) => {
          const story = c.cases[k.id]
          return (
            <article
              key={`${branch}-${k.id}`}
              className='dm-case'
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className='dm-case__top'>
                <img className='dm-case__logo' src={k.logo} alt={story.name} />
                <span className='dm-case__branch'>{story.branch}</span>
              </div>
              <div className='dm-case__value'>{story.value}</div>
              <div className='dm-case__value-label'>{story.valueLabel}</div>
              <p className='dm-case__text'>{story.text}</p>
              <blockquote className='dm-case__quote'>{story.quote}</blockquote>
              <div className='dm-case__author'>
                <Avatar initials={k.initials} color='blue' size={36} />
                <span>{story.author}</span>
              </div>
            </article>
          )
        })}
      </div>
    </div>
  )
}
